import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mActionInvertSelection",
  "use": "mActionInvertSelection-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"mActionInvertSelection\"><g fill-rule=\"evenodd\"><path fill=\"#fce94f\" stroke=\"#c4a000\" d=\"M2.5 21.5V4.146L19.854 21.5z\" /><path fill=\"#ebebeb\" stroke=\"#898989\" d=\"M21.5 2.5v17.354L4.146 2.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbolimport SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mActionInvertSelection",
  "use": "mActionInvertSelection-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"mActionInvertSelection\"><g fill-rule=\"evenodd\"><path fill=\"#fce94f\" stroke=\"#c4a000\" d=\"M2.5 21.5V4.146L19.854 21.5z\" /><path fill=\"#ebebeb\" stroke=\"#898989\" d=\"M21.5 2.5v17.354L4.146 2.5z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol